// Custom scripts
import Darowizna from "./darowizna";
import PopupZaloguj from "../koszyk/popup-zaloguj";

(() => {
    if (typeof $ === "undefined") {
        throw new TypeError("... requires jQuery.");
    }

    $(document).ready(() => {
        const darowizna = new Darowizna();
        const popupZaloguj = new PopupZaloguj();

        darowizna.init();
        popupZaloguj.init();
    });
})();
